import PropTypes from 'prop-types';
import YesNoButtonInput from '@components/input/yes-no-button.input.jsx';
import { useSubathonTimerSettingsModifiers } from './subathon-timer.hooks.js';
import { useCallback } from 'preact/hooks';
import NumberSliderInput from '@components/input/number-slider.input.jsx';

SubathonTimerSettings.propTypes = {
  settings: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  buttonsDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default function SubathonTimerSettings({
  settings,
  onReset,
  onSave,
  disabled = false,
  isLoading = false,
  buttonsDisabled = false,
}) {
  const {
    handleNegativeTimeAllowedChange,
    negativeTimeAllowed,
    contentChanged,
    handleEndTimeOffsetChange,
    endTimeOffset,
    isNew,
  } = useSubathonTimerSettingsModifiers(settings);
  const handleOnSave = useCallback(() => {
    onSave({
      ...settings,
      negativeTimeAllowed,
      endTimeOffset,
    });
  }, [settings, onSave, negativeTimeAllowed, endTimeOffset]);

  const loadingBlock = (
    <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
      <span className="loading loading-spinner loading-md"></span>
    </div>
  );

  const settingsBlock = (
    <>
      <YesNoButtonInput
        disabled={disabled}
        onChange={handleNegativeTimeAllowedChange}
        mode="checkbox"
        currentValue={negativeTimeAllowed ? 'yes' : 'no'}
        name="allowNegative"
        label="Allow negative timer effects"
      />

      <NumberSliderInput
        disabled={disabled}
        labelText="Initial timer minutes"
        fieldName="endTimeOffset"
        onChange={handleEndTimeOffsetChange}
        value={endTimeOffset}
        minValue={1}
        maxValue={10}
        inputClassName="w-full"
        description={<>The initial value in minutes of the timer.</>}
      />

      <div className="flex justify-between items-center w-full mt-4">
        <button
          className="btn btn-accent btn-sm"
          onClick={() => onReset(settings)}
          disabled={isNew || disabled || buttonsDisabled}
        >
          Reset
        </button>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => handleOnSave()}
          disabled={!contentChanged || disabled || buttonsDisabled}
        >
          Save
        </button>
      </div>

      <div className="w-full mt-2">
        <span
          className={`text-red-500 text-sm ${disabled ? 'opacity-90' : 'opacity-0'}`}
        >
          Please select a campaign above first
        </span>
      </div>
    </>
  );

  return (
    <div className="relative h-[215px]">
      {isLoading ? loadingBlock : settingsBlock}
    </div>
  );
}
